<div class="ml-3">{{ valueSignal() | number: '1.2' }}</div>
